// A pending history restore must yield as soon as the user starts scrolling,
// another route opens, or the catalog has restored its more precise anchor.
export function createScrollRestoreGuard(expectedPath?: string) {
  const initialPath =
    expectedPath || window.location.pathname + window.location.search;
  const position = window.history?.state?.position;
  let stopped = false;
  const dispose = () => {
    stopped = true;
    window.removeEventListener("wheel", dispose, true);
    window.removeEventListener("touchmove", dispose, true);
    window.removeEventListener("keydown", onKey, true);
    window.removeEventListener("popstate", dispose, true);
    window.removeEventListener("vf-catalog-scroll-restore", dispose);
  };
  const onKey = (event: KeyboardEvent) => {
    if (
      [
        "ArrowUp",
        "ArrowDown",
        "PageUp",
        "PageDown",
        "Home",
        "End",
        " ",
      ].includes(event.key)
    )
      dispose();
  };
  window.addEventListener("wheel", dispose, { capture: true, passive: true });
  window.addEventListener("touchmove", dispose, {
    capture: true,
    passive: true,
  });
  window.addEventListener("keydown", onKey, true);
  window.addEventListener("popstate", dispose, true);
  window.addEventListener("vf-catalog-scroll-restore", dispose);
  return {
    isActive: () =>
      !stopped &&
      initialPath === window.location.pathname + window.location.search &&
      position === window.history?.state?.position,
    dispose,
  };
}
